// extracted by mini-css-extract-plugin
module.exports = {"container":"mobile_summary_container_container__5DwoE"};